"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLayout = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var tokens = __importStar(require("@iqmetrix/style-tokens"));
function isContent(obj) {
    return obj && obj.children !== undefined;
}
var Layout = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: ", ";\n  margin-left: ", ";\n\n  @media ", " {\n    margin-right: ", ";\n    margin-left: ", ";\n  }\n\n  @media ", " {\n    margin-right: 0;\n    margin-left: 0;\n  }\n"], ["\n  margin-right: ", ";\n  margin-left: ", ";\n\n  @media ", " {\n    margin-right: ",
    ";\n    margin-left: ",
    ";\n  }\n\n  @media ", " {\n    margin-right: 0;\n    margin-left: 0;\n  }\n"])), tokens.SpacingLayoutXlarge, tokens.SpacingLayoutXlarge, tokens.MediaQueriesXlarge, function (props) {
    return props.size === "small"
        ? tokens.SpacingLayoutXxxlarge
        : tokens.SpacingLayoutXlarge;
}, function (props) {
    return props.size === "small"
        ? tokens.SpacingLayoutXxxlarge
        : tokens.SpacingLayoutXlarge;
}, tokens.MediaQueriesXsmall);
var Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  position: relative;\n  padding-top: ", ";\n  margin: auto;\n  max-width: ", ";\n\n  @media ", " {\n    padding-top: ", ";\n  }\n"], ["\n  display: block;\n  position: relative;\n  padding-top: ", ";\n  margin: auto;\n  max-width: ",
    ";\n\n  @media ", " {\n    padding-top: ", ";\n  }\n"])), tokens.SpacingLayoutLarge, function (props) {
    return props.size === "small" ? tokens.WidthLayoutSmall : tokens.WidthLayoutLarge;
}, tokens.MediaQueriesXsmall, tokens.SpacingBaseLarge);
var SectionContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: ", ";\n"], ["\n  position: ", ";\n"])), function (props) { return (props.affix ? "fixed" : "inherit"); });
var Section = function (props) {
    if (!props.children)
        return null;
    var content = isContent(props.children)
        ? props.children
        : {
            children: props.children
        };
    return React.createElement(SectionContainer, __assign({}, props, content));
};
var Header = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: ", ";\n\n  @media ", " {\n    margin-bottom: ", ";\n  }\n"], ["\n  margin-bottom: ", ";\n\n  @media ", " {\n    margin-bottom: ", ";\n  }\n"])), tokens.SpacingLayoutLarge, tokens.MediaQueriesXsmall, tokens.SpacingBaseLarge);
var Messages = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), tokens.SpacingBaseLarge);
var PageContent = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n\n  @media ", " {\n    flex-direction: column;\n  }\n\n  @media ", " {\n    flex-direction: column;\n  }\n\n  & + * {\n    margin: ", " 0 0 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n\n  @media ", " {\n    flex-direction: column;\n  }\n\n  @media ", " {\n    flex-direction: column;\n  }\n\n  & + * {\n    margin: ", " 0 0 0;\n  }\n"])), tokens.MediaQueriesSmall, tokens.MediaQueriesXsmall, tokens.SpacingLayoutBase);
var Primary = styled_components_1.default(Section)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  flex: 2 1 66.33%;\n\n  & + * {\n    margin: 0 0 0 ", ";\n  }\n\n  @media ", " {\n    & + * {\n      margin: ", " 0 0 0;\n    }\n  }\n\n  @media ", " {\n    & + * {\n      margin: ", " 0 0 0;\n    }\n  }\n"], ["\n  flex: 2 1 66.33%;\n\n  & + * {\n    margin: 0 0 0 ", ";\n  }\n\n  @media ", " {\n    & + * {\n      margin: ", " 0 0 0;\n    }\n  }\n\n  @media ", " {\n    & + * {\n      margin: ", " 0 0 0;\n    }\n  }\n"])), tokens.SpacingLayoutBase, tokens.MediaQueriesSmall, tokens.SpacingLayoutBase, tokens.MediaQueriesXsmall, tokens.SpacingLayoutBase);
var Secondary = styled_components_1.default(Section)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  flex: 2 1 33.33%;\n"], ["\n  flex: 2 1 33.33%;\n"])));
var Ternary = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), tokens.SpacingLayoutXxlarge);
exports.PageLayout = function (props) {
    var size = props.size ? props.size : "small";
    return (React.createElement(Layout, { size: size },
        React.createElement(Container, { size: size },
            React.createElement(Header, null, props.children.header),
            props.children.messages && (React.createElement(Messages, null, props.children.messages)),
            props.children.content.map(function (contentSection, index) { return (React.createElement(PageContent, { key: index },
                React.createElement(Primary, null, contentSection.primary),
                contentSection.secondary && (React.createElement(Secondary, null, contentSection.secondary)))); }),
            props.children.ternary && React.createElement(Ternary, null, props.children.ternary))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=page-layout.js.map